import Page from "@adora/shared/components/layout/page";
import { Box, Button, Flex, Typography } from "flux";
import { useNavigate } from "react-router-dom";

const tools = [
  {
    name: "Create Trial Brand",
    description:
      "Set up a new trial brand end-to-end: create brand, provision S3/CDN infra, generate system prompt, and onboard users.",
    path: "/tools/brand-onboarding"
  },
  {
    name: "Creative Evaluation",
    description: "Review generated images, label creative issues, and save golden evaluation tags.",
    path: "/tools/creative-eval"
  }
];

const Tools: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Page title="Tools">
      <Flex flexDirection="column" gap="12px" width="100%" maxWidth="900px" mx="auto">
        {tools.map((tool) => (
          <Flex
            key={tool.path}
            alignItems="center"
            justifyContent="space-between"
            gap="24px"
            sx={{
              border: "1px solid",
              borderColor: "rgb(226 232 240)",
              borderRadius: "8px",
              bgcolor: "white",
              px: "20px",
              py: "16px",
              boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)"
            }}
          >
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                {tool.name}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {tool.description}
              </Typography>
            </Box>
            <Button
              variant="contained"
              onClick={() => navigate(tool.path)}
              dataDogIdentifier={`tools run ${tool.name.toLowerCase().replaceAll(" ", "-")}`}
            >
              Run
            </Button>
          </Flex>
        ))}
      </Flex>
    </Page>
  );
};

export default Tools;
